import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import { distributeService } from "services/distributeCoinService";
import Select from "components/Select/Select";
import { chainOptions } from "const";

const useStyles = makeStyles(styles);

export default function DistributeCoinCreate() {
  const { register: coin, handleSubmit, setValue, control } = useForm();
  const { id } = useParams();
  const history = useHistory();

  async function create(payload) {
    try {
      await distributeService.create({ ...payload, icon: payload.image });
      toast.success("Created");
    } catch (e) {
      toast.error(e?.response?.data?.message[0]);
      console.log(e);
    }
  }

  async function update(payload) {
    try {
      await distributeService.update(id, { ...payload, icon: payload.image });
      toast.success("Updated");
    } catch (e) {
      toast.error(e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    }
  }

  async function onSubmit(form) {
    if (id) {
      update({ ...form, chainId: form.chainId || 25 });
    } else {
      create({ ...form, chainId: form.chainId || 25 });
    }
  }

  async function fetchCoins() {
    try {
      const { data } = await distributeService.getCoinById(id);
      const fields = ["name", "address", "icon", "chainId"];
      fields.forEach((field) => setValue(field, data[field]));
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchCoins();
    }
  }, [id]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {!id ? "Create Distribute Coin" : "Edit Distribute Coin"}
            </h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Name</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...coin("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Address</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...coin("address"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Chain</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="chainId"
                            label=" "
                            onChange={onChange}
                            value={value ?? 25}
                            options={chainOptions()}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9}>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                      <Button color="rose" type="submit">
                        Submit
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Icon: </p>
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { value, onChange } }) => (
                          <ImageUpload value={value} onChange={onChange} />
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}></GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
